import { render, staticRenderFns } from "./annualDetails.vue?vue&type=template&id=5383cd5c&scoped=true&"
import script from "./annualDetails.vue?vue&type=script&lang=js&"
export * from "./annualDetails.vue?vue&type=script&lang=js&"
import style0 from "./annualDetails.vue?vue&type=style&index=0&id=5383cd5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383cd5c",
  null
  
)

export default component.exports